// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__33YIC","modalFooterButton":"ModalNotes_modalFooterButton__14d9o"};